export const birthdayMask = '__/__/____'